import { NgModule } from '@angular/core';
import {
  AccordionAnchorDirective,
  AccordionDirective,
  AccordionLinkDirective
} from './directives/accordion';
import { MenuItems } from './menu-items/menu-items';



@NgModule({
  entryComponents: [

  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective
  ],
  providers: [MenuItems]
})
export class SharedModule { }
